import type { PrayerMethod } from './prayer-times';

export interface AppSettings {
  method: PrayerMethod;
  hanafi: boolean;
  vibration: boolean;
  infiniteTasbih: boolean;
  latitude: number;
  longitude: number;
  timeZone: string;
  locationName: string;
  locationCountry?: string;
  locationSource: 'fallback' | 'browser' | 'manual' | 'search';
  tasbihCount: number;
}

export const DEFAULT_SETTINGS: AppSettings = {
  method: 'Diyanet',
  hanafi: true,
  vibration: true,
  infiniteTasbih: false,
  latitude: 49.1426929,
  longitude: 9.210879,
  timeZone: 'Europe/Berlin',
  locationName: 'Heilbronn',
  locationCountry: 'Deutschland',
  locationSource: 'fallback',
  tasbihCount: 0,
};

const STORAGE_KEY = '4eternity.web.settings.v2';
const LEGACY_STORAGE_KEY = '4eternity.web.settings.v1';

export function loadSettings(): AppSettings {
  try {
    const stored = localStorage.getItem(STORAGE_KEY) ?? localStorage.getItem(LEGACY_STORAGE_KEY);
    if (!stored) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(stored) as Partial<AppSettings>;
    return { ...DEFAULT_SETTINGS, ...parsed };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveSettings(settings: AppSettings): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}
